import { Button, IconButton, InputBase, makeStyles, Paper } from '@material-ui/core'
import React, { memo, useCallback, useState } from 'react'
import SearchIcon from '@material-ui/icons/Search'
import DeleteIcon from '@material-ui/icons/Delete'

const useStyles = makeStyles((theme) => ({
  phrase: {
    margin: '1rem',
    padding: '1rem',
  },
  searchControlWrapper: {
    border: '1px solid gray',
    borderRadius: '5px',
    width: 'max-content',
    minWidth: '15%',
    maxWidth: '50ch',
    display: 'flex',
    marginBottom: '0.5rem'
  },
  vocabControlHeading: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  groupButton: {
    fontSize: '14px',
    margin: '0 0.5rem',
    marginBottom: '0.5rem'
  },
  searchText: {
    margin: '0.5rem',
    fontSize: '12px',
    width: '100%',
  },
  searchIcon: {
    verticalAlign: 'middle',
    margin: 'auto',
    marginRight: '1rem',
  },
  phraseContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  deleteIcon: {
    padding: '4px',
  },
}))

const MemoPaper = memo((props) => {
  const { phrase, classes, onDelete, index } = props
  const handleDelete = () => {
    onDelete(index)
  }
  return (
    <Paper className={classes.phrase}>
      {phrase}
      <IconButton onClick={handleDelete} className={classes.deleteIcon}>
        <DeleteIcon />
      </IconButton>
    </Paper>
  )
})

const VocabList = memo((props) => {
  let { vocabData, deleteVocab, group, setGroup } = props
  const [search, setSearch] = useState('')

  const classes = useStyles()

  const handleDelete = useCallback(
    (index) => {
      deleteVocab(index)
    },
    [vocabData.length]
  )

  const GroupPagination = []
  if (vocabData.length > 1000) {
    for (let i = 0; i < vocabData.length; i += 1000) {
      GroupPagination.push(
        <Button
          disabled={i / 1000 === group}
          variant='contained'
          className={classes.groupButton}
          onClick={() => setGroup(i / 1000)}
        >
          {i / 1000}000 - {(i + 1000) / 1000}000
        </Button>
      )
    }
  }
  if (vocabData.length === 0) {
    return <div>No vocabulary terms have been created. The info button in the top right has details about how to use this vocabulary area.</div>
  }

  return (
    <div>
      <div className={classes.vocabControlHeading}>
        <div className={classes.searchControlWrapper}>
          <InputBase
            className={classes.searchText}
            value={search}
            onChange={(e) => {
              setSearch(e.target.value)
            }}
          />
          <SearchIcon className={classes.searchIcon} />
        </div>
        <div>{GroupPagination}</div>
      </div>
      <div className={classes.phraseContainer}>
        {vocabData.map((phrase, i) => {
          if (search.length && !phrase.toLowerCase().includes(search.toLowerCase())) {
            return null
          }
          if (i < group * 1000 || i >= (group + 1) * 1000) {
            return null
          }
          return (
            <MemoPaper
              key={`vocab phrase${phrase}`}
              phrase={phrase}
              classes={classes}
              index={i}
              onDelete={handleDelete}
            />
          )
        }).sort((a,b) => {
          if (!a && b) return 1
          if (a && !b) return -1
          if (!a && !b) return 0
          //sort elements by phrase alphabetically
          const phraseA = a.props.phrase.toLowerCase()
          const phraseB = b.props.phrase.toLowerCase()
          if (phraseA < phraseB) return -1
          if (phraseA > phraseB) return 1
          return 0
        })}
      </div>
    </div>
  )
})

export default VocabList
